import React from 'react';

export default function ({ children, span, spanRow = null }) {
    return (
        <td role="cell" data-pc-section="bodycell" style={{
            border: "0.5px solid  #dee2e6", borderCollapse: "collapse",
        }} colSpan={span} rowSpan={spanRow} >
            {children}
        </td>
    );
}
